export const monthsList = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר',
  'נובמבר',
  'דצמבר',
];

export const numberToMonthText = (month: number) => {
  return monthsList[month];
};

export const monthTextToNumber = (month: string) => {
  const monthIndex = monthsList.indexOf(month);
  return monthIndex;
};
